export default function MothersDayScreenshot(){
    return (
        <>
            <img src='mothers-day-screenshot.webp' style={{maxWidth:'100%'}} />
            

        </>
    )
}